import React from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import TopSection from '../../components/PrivacyPolicy/index';
import ContactForm from '../../components/PrivacyPolicy/PrivacyPolicy';



const PrivaacyPolicyIndex=props=>{

    return(
        <div> 
            <Navbar bg="blue"/>
            <div className='max-md:p-3'>
            <TopSection/>
            <ContactForm/>
            
            </div>
            <Footer/>
        </div>
    )
}
export default PrivaacyPolicyIndex